module.exports = __webpack_public_path__ + "fonts/083662cca067cf52ac4c2d16ca877db9.svg";